import { useWidget } from '@telescope/cassini-hooks';
import {
  Button,
  ButtonGroup,
  Flex,
  useColorModeValue
} from '@telescope/cassini-ui';
import { useAuth } from '../lib';
import { Open } from 'types';

export const AuthNav = () => {
  const { user, logout } = useAuth();
  const { data: authData } = useWidget({ select: (data: Open) => data.widget.global_views.auth });
  const { content } = authData!

  const handleLogout = async () => {
    await logout();
  };

  if (!user) return null;

  return (
    <Flex className="AuthNav" justifyContent="flex-end" mb={3}>
      <ButtonGroup className="AuthNav__auth-btn-group" size="sm">
        <Button className="AuthNav__logout-btn" variant="link" onClick={handleLogout} textDecoration="underline">
          {content.user.logoutCTA}
        </Button> 
      </ButtonGroup>
    </Flex>
  );
};
